import { createTimeAssignment } from "@/api/timeAssignments/createTimeAssignment"
import { useMutation } from "@tanstack/react-query"

export const useCreateTimeAssignment = () => {

  return useMutation({
    mutationKey: ["createTimeAssignment"],
    mutationFn: createTimeAssignment
  })
}